import { render, staticRenderFns } from "./configH5Video.vue?vue&type=template&id=dbb98cc8&scoped=true&"
import script from "./configH5Video.vue?vue&type=script&lang=js&"
export * from "./configH5Video.vue?vue&type=script&lang=js&"
import style0 from "./configH5Video.vue?vue&type=style&index=0&id=dbb98cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb98cc8",
  null
  
)

export default component.exports